import React, { useState, useEffect } from 'react';
import { Modal, Box, Button } from '@cloudscape-design/components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PaymentBlockedModal() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { trialStatus } = useAuth();

  useEffect(() => {
    // Show blocking modal for 'blocked' state (≤ $5.00)
    if (trialStatus.needsPayment === 'blocked') {
      const publicPaths = ['/', '/privacy', '/terms', '/login', '/register'];
      const isPublicPath = publicPaths.includes(location.pathname);
      
      // Don't show modal on public pages
      if (isPublicPath) {
        setVisible(false);
        return;
      }
      
      // Show modal on payment-setup page and protected routes (always, not just once)
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [trialStatus.needsPayment, location.pathname]);

  const handleDismiss = () => {
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      onDismiss={handleDismiss}
      header="Payment Method Required"
      footer={
        <Box float="right">
          <Button variant="primary" onClick={handleDismiss}>
            Got It
          </Button>
        </Box>
      }
    >
      <Box>
        Your trial credits are getting low. To continue using Recapify, please add a payment method.
        <br /><br />
        <strong>What you need to know:</strong>
        <ul>
          <li>You can still use your remaining trial credits</li>
          <li>You'll only be charged after your trial credits are fully consumed</li>
          <li>Pay-per-use pricing with monthly invoices</li>
          <li>No commitments - cancel anytime</li>
        </ul>
      </Box>
    </Modal>
  );
}

export default PaymentBlockedModal;
